module.exports = __webpack_public_path__ + "static/media/manual_placements_mark_complete_confirm.1b9155fc.mov";